import type { AxiosRequestConfig } from 'axios';

import type { ApiResponse } from '@/entities/api-response/types';

import { apiClient } from './client';

/**
 * Función única reutilizable para todas las peticiones del frontend.
 * Desempaqueta el envelope `{ success, data, timestamp }` del backend
 * y retorna directamente `data` con el tipo solicitado.
 *
 * Ejemplo:
 *   const user = await request<User>({ method: 'GET', url: '/auth/me' });
 */
export async function request<TResponse, TBody = unknown>(
  config: AxiosRequestConfig<TBody>,
): Promise<TResponse> {
  const { data } = await apiClient.request<ApiResponse<TResponse>>(config);
  return data.data;
}
